import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken.jsx';

const saveDraft = async (draft) => {

    const handleResponse = (response) => {
        const errors = response.data.errors;
        const body = response.data.body;

        if (errors && errors.length > 0){
            console.log('Errors:', errors);
        }
    }

    try{
        const accessToken = await retrieveAccessToken();
        const response = await axios.post(
            '/api/editor/draft',
            draft,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        handleResponse(response);
    }
    catch (error){
        console.log(error)
    }

}
export {saveDraft}
